<nav class="sticky top-0 z-40 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 shadow-sm transition-colors duration-300">
  <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-14">

      <!-- Logo -->
      <a routerLink="/" class="flex items-center shrink-0">
        @if (_customizer.dark()) {
          <img
            src="assets/images/hcs-logo-dark-300x60.png"
            srcset="assets/images/hcs-logo-dark-300x60.png 300w,
                    assets/images/hcs-logo-dark-768x154.png 768w,
                    assets/images/hcs-logo-dark-1024x205.png 1024w"
            sizes="(max-width: 640px) 160px, 200px"
            alt="habitualcs.io"
            class="h-8 w-auto"
          />
        } @else {
          <img
            src="assets/images/hcs-logo-300x59.png"
            srcset="assets/images/hcs-logo-253x50.png 253w,
                    assets/images/hcs-logo-300x59.png 300w,
                    assets/images/hcs-logo-768x151.png 768w,
                    assets/images/hcs-logo-1024x201.png 1024w"
            sizes="(max-width: 640px) 160px, 200px"
            alt="habitualcs.io"
            class="h-8 w-auto"
          />
        }
      </a>

      <!-- Desktop nav links -->
      <div class="hidden md:flex items-center gap-6" role="navigation" aria-label="Main navigation">
        <a routerLink="/" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="!text-[var(--reader-accent)]" ariaCurrentWhenActive="page"
           class="no-underline text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-[var(--reader-accent)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)] rounded">
          Home
        </a>
        <a routerLink="/about" routerLinkActive="!text-[var(--reader-accent)]" ariaCurrentWhenActive="page"
           class="no-underline text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-[var(--reader-accent)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)] rounded">
          About
        </a>
        <a routerLink="/contact" routerLinkActive="!text-[var(--reader-accent)]" ariaCurrentWhenActive="page"
           class="no-underline text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-[var(--reader-accent)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)] rounded">
          Contact
        </a>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-2">

        <!-- Dark mode toggle -->
        <button (click)="toggleTheme()"
                aria-label="Toggle dark mode"
                class="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)]">
          @if (_customizer.dark()) {
            <!-- Sun icon -->
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707M18.364 17.657l-.707-.707M6.343 6.343l-.707-.707M12 8a4 4 0 100 8 4 4 0 000-8z"/>
            </svg>
          } @else {
            <!-- Moon icon -->
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>
            </svg>
          }
        </button>

        <!-- Reading preferences toggle -->
        <button (click)="_customizer.toggle()"
                [attr.aria-expanded]="_customizer.isOpen()"
                aria-label="Reading preferences"
                [class]="_customizer.isOpen()
                  ? 'p-2 rounded-lg text-[var(--reader-accent)] bg-[color-mix(in_srgb,var(--reader-accent)_12%,transparent)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)]'
                  : 'p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)]'">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
          </svg>
        </button>

        <!-- Bookmarks link with badge -->
        <a routerLink="/bookmarks"
           aria-label="Bookmarks"
           class="relative p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
          </svg>
          @if (bookmarkCount() > 0) {
            <span class="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--reader-accent)] px-1 text-[10px] font-bold leading-none text-white">
              {{ bookmarkCount() > 99 ? '99+' : bookmarkCount() }}
            </span>
          }
        </a>

        <!-- Auth section -->
        @if (currentUser()) {
          <div class="relative">
            <button (click)="toggleUserMenu()"
                    class="flex items-center justify-center w-8 h-8 rounded-full bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-500 transition-colors">
              {{ userInitial }}
            </button>

            @if (userMenuOpen()) {
              <!-- Backdrop -->
              <div class="fixed inset-0 z-10" (click)="closeUserMenu()"></div>
              <!-- Dropdown -->
              <div class="absolute right-0 mt-2 w-44 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-lg z-20 py-1 animate-fade-in">
                <a routerLink="/profile" (click)="closeUserMenu()"
                   class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
                  Profile
                </a>
                <a routerLink="/bookmarks" (click)="closeUserMenu()"
                   class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
                  Bookmarks
                </a>
                <hr class="my-1 border-gray-200 dark:border-gray-700">
                <button (click)="signOut()"
                        class="w-full text-left flex items-center gap-2 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-50 dark:hover:bg-gray-700">
                  Sign Out
                </button>
              </div>
            }
          </div>
        } @else {
          <a routerLink="/auth/login"
             class="hidden sm:inline-flex text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors px-3 py-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
            Sign In
          </a>
        }

        <!-- Mobile menu toggle -->
        <button (click)="toggleMobileMenu()"
                [attr.aria-expanded]="mobileMenuOpen()"
                aria-controls="mobile-menu"
                aria-label="Toggle menu"
                class="md:hidden p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)]">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile menu -->
  @if (mobileMenuOpen()) {
    <div id="mobile-menu" class="md:hidden border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-4 py-3 space-y-1" role="navigation" aria-label="Mobile navigation">
      <a routerLink="/" (click)="toggleMobileMenu()" routerLinkActive="!text-[var(--reader-accent)] bg-gray-50 dark:bg-gray-800" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page"
         class="no-underline block px-3 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800">
        Home
      </a>
      <a routerLink="/about" (click)="toggleMobileMenu()" routerLinkActive="!text-[var(--reader-accent)] bg-gray-50 dark:bg-gray-800" ariaCurrentWhenActive="page"
         class="no-underline block px-3 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800">
        About
      </a>
      <a routerLink="/contact" (click)="toggleMobileMenu()" routerLinkActive="!text-[var(--reader-accent)] bg-gray-50 dark:bg-gray-800" ariaCurrentWhenActive="page"
         class="no-underline block px-3 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800">
        Contact
      </a>
      @if (!currentUser()) {
        <a routerLink="/auth/login" (click)="toggleMobileMenu()"
           class="block px-3 py-2 rounded-lg text-sm font-medium text-indigo-600 dark:text-indigo-400 hover:bg-gray-100 dark:hover:bg-gray-800">
          Sign In
        </a>
      }
    </div>
  }
</nav>
